import { useEffect, useState } from 'react';
import { Box, MenuItem, MenuList, Typography } from '@mui/material';
import { useNotificaciones } from '../hooks/useNotificaciones';
import { NotificacionItem } from './NotificacionItem';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

export const NotificacionListMobile = () => {
  var { notificacionesList, leerNotificacion, loading, notificacionesCount } = useNotificaciones();
  const [update, setUpdate] = useState(false);
  const history = useHistory();
  const [notificacionesActualizadas, setNotificacionesActualizadas] = useState([]);

  useEffect(() => {
    if (notificacionesActualizadas?.length > 0 || update) {
      setNotificacionesActualizadas(notificacionesActualizadas);
      setUpdate(true);
    } else {
      setNotificacionesActualizadas(notificacionesList);
    }
  }, [notificacionesList, notificacionesActualizadas]);

  const deleteItem = (itemToDelete) => {
    const updatedMenuItems = notificacionesActualizadas.filter((item) => item !== itemToDelete);
    setNotificacionesActualizadas(updatedMenuItems);
  };

  const onMenuItemClick = async (notificacion) => {
    const res = await leerNotificacion(notificacion);
    if (res) deleteItem(notificacion);

    if (notificacion.codigoTipoNotificacion === 'RecetaMedicaIfx') {
      history.push({
        pathname: '/ver-receta-cronica/' + JSON.stringify(notificacion.idSolicitud),
        state: { notificacion: notificacion } || {}, // your data array of objects
      });
    } else if (notificacion.codigoTipoNotificacion === 'PrescripcionElectronica') {
      history.push({
        pathname: '/ver-prescripcion/' + JSON.stringify(notificacion.idSolicitud),
        state: { notificacion: notificacion } || {}, // your data array of objects
      });
    } else if (notificacion.codigoTipoNotificacion === 'ORDEN_AUTOMATICA') {
      history.push({
        pathname: '/ver-orden-automatica/' + JSON.stringify(notificacion.idSolicitud),
        state: { notificacion: notificacion } || {}, // your data array of objects
      });
    } else {
      history.push({
        pathname: '/autorizaciones',
        state: {}, // your data array of objects
      });
    }
  };

  return (
    <>
      <MenuList autoFocus={false} autoFocusItem={true}>
        {loading &&
          [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => {
            return (
              <MenuItem key={item} sx={{ px: 0 }}>
                <NotificacionItem {...item} loading />
              </MenuItem>
            );
          })}
        {!loading && notificacionesCount < 1 && (
          <Box m={2}>
            <Typography variant='body2' color='text.secondary' style={{ textWrap: 'wrap' }}>
              No se encontraron notificaciones.
            </Typography>
          </Box>
        )}
        {!loading &&
          notificacionesCount > 0 &&
          notificacionesActualizadas?.map((item) => {
            return (
              <MenuItem
                key={item.numeroNotificacion}
                onClick={() => {
                  onMenuItemClick(item);
                }}
                sx={{ px: 0 }}
              >
                <NotificacionItem {...item} />
              </MenuItem>
            );
          })}
      </MenuList>
    </>
  );
};
